import { Box } from "@chakra-ui/react"
import { Outlet } from "react-router-dom"
import Navbar from "../Navbar"

const WebsiteLayout: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Outlet />
    </Box>
  )
}

export default WebsiteLayout
